import React, { useContext } from 'react';
import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/BasicUserName';
import { getMoreByLinkType } from '../../helpers';
import s from './MoreByAuthor.scss';
var MoreByAuthor = function (_a) {
    var contentType = _a.contentType, author = _a.author, className = _a.className;
    var isMobile = useContext(MobileContext);
    var updated_sidebar_styles = useFlag('updated_sidebar_styles');
    var rootClass = !isMobile && updated_sidebar_styles
        ? 'by-author-updated_sidebar_styles'
        : 'by-author';
    var i18n = useTranslation().i18n;
    var defaultKey = "sidebar.blockTitle.".concat(contentType);
    var updatedKey = "".concat(defaultKey, ".updated_sidebar_styles");
    var i18nKey = !isMobile && updated_sidebar_styles && i18n.exists(updatedKey)
        ? updatedKey
        : defaultKey;
    return (React.createElement(UserLink, { className: classnames(s[rootClass], className), user: author, linkTo: getMoreByLinkType(contentType) },
        React.createElement(Trans, { i18nKey: i18nKey },
            "More things by ",
            React.createElement(BasicUserName, { usernameClassName: s['username'], user: author }))));
};
MoreByAuthor.displayName = 'MoreByAuthor';
export default MoreByAuthor;
//# sourceMappingURL=MoreByAuthor.js.map